import {faqBbsService} from '@/services/faqBbs.service';

const state = {
    unReadFaqBbs: null,
    faqBbsListModel: null,
    subFaqBbsListModel: null,
    faqBbsModel: null,
    faqBbsCategoryListModel: null,
    faqBbsCategoryList: [],
    commentList: [],
    chargeAdminList: []
}

function downloadFile(res, name) {
    if (res.status === 200) {
        let filename = name;
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                const arr = matches[1].toString().split("''");
                filename = arr.length > 1 ? arr.pop() : arr.shift();

                if (typeof filename === "string") {
                    filename = decodeURIComponent(filename);
                }
            }
        }

        const url = window.URL.createObjectURL(res.body);
        const link = document.createElement('a');
        link.href = url;
        if (filename != null) {
            link.setAttribute('download', filename);
        }
        document.body.appendChild(link);
        link.click();
    }
}

function downloadFileFromUrl(url) {
    if (!url) return
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
}

const getters = {
    faqBbsList: (state) => {
        if (!state.faqBbsListModel) return []
        return state.faqBbsListModel.data || []
    },
    subFaqBbsList: (state) => {
        if (!state.subFaqBbsListModel) return []
        return state.subFaqBbsListModel.data || []
    },
    faqBbsCategoryList: (state) => {
        if (!state.faqBbsCategoryListModel) return []
        return state.faqBbsCategoryListModel.data || []
    },
    faqBbs: (state) => {
        if (!state.faqBbsModel) return {}
        return state.faqBbsModel.data || {}
    },
    totalPages: (state) => {
        if (!state.faqBbsListModel) return 1
        return state.faqBbsListModel.last_page || 1
    },
    totalRows: (state) => {
        if (!state.faqBbsListModel) return 0
        return state.faqBbsListModel.total || 0
    },
    subTotalPages: (state) => {
        if (!state.subFaqBbsListModel) return 1
        return state.subFaqBbsListModel.last_page || 1
    },
    subTotalRows: (state) => {
        if (!state.subFaqBbsListModel) return 0
        return state.subFaqBbsListModel.total || 0
    },
    currentPage: (state) => {
        if (!state.faqBbsListModel) return 1
        return state.faqBbsListModel.current_page || 1
    },
    unReadFaqBbs: (state) => {
        return state.unReadFaqBbs
    },
    getFaqBbsCategoryList: (state) => {
        return state.faqBbsCategoryList
    },
}


const mutations = {
    SET_FAQ_BBS_LIST_MODEL(state, payload){
        state.faqBbsListModel = payload
    },
    SET_SUB_FAQ_BBS_LIST_MODEL(state, payload){
        state.subFaqBbsListModel = payload
    },
    SET_FAQ_BBS_MODEL(state, payload){
        state.faqBbsModel = payload
    },
    SET_FAQ_BBS_CATEGORY_LIST_MODEL(state, payload){
        state.faqBbsCategoryList = payload
    },
    SET_BBS_LIST_CURRENT_PAGE(state, payload) {
        if(!state.faqBbsListModel) return
        state.faqBbsListModel.current_page = payload
    },
    SET_COMMENT_LIST(state, payload) {
        state.commentList = payload
    },
    SET_UNREAD_FAQ_BBS(state, payload){
        state.unReadFaqBbs = payload
    },
    SET_CHARGE_ADMINS(state, payload){
      state.chargeAdminList = payload
    },
}


const actions = {
    async fetchFaqBbsList({ dispatch, commit }, queryParams) {
        try {
            const response =  await faqBbsService.fetchFaqBbsList(queryParams)
            if (response.success){
                commit('SET_FAQ_BBS_LIST_MODEL', response.data)
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async fetchFaqBbsCategoryList({ dispatch, commit }, queryParams) {
        try {
            const response =  await faqBbsService.fetchFaqBbsCategoryList(queryParams)
            if (response.success){
                commit('SET_FAQ_BBS_CATEGORY_LIST_MODEL', response.data)
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },

    async getFaqBbs({ dispatch, commit }, bbsId) {
        try {
            const response =  await faqBbsService.getFaqBbs(bbsId)
            if (response.success){
                commit('SET_FAQ_BBS_MODEL', response.data)
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return null
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return null;
        }
    },

    async createFaqBbs({ dispatch, commit }, payload) {
        try {
            const response =  await faqBbsService.createFaqBbs(payload)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },

    async updateFaqBbs({ dispatch, commit }, {id, faqData}) {
        try {
            const response =  await faqBbsService.updateFaqBbs(id, faqData)
            if (response.success){
                dispatch("alertSuccess", response.message, { root: true });
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },

    async deleteFaqBbsNewIcon({ dispatch, commit }, bbs_id) {
        try {
            const response =  await faqBbsService.deleteFaqBbsNewIcon(bbs_id)
            if (response.success){
                dispatch("alertSuccess", response.message, { root: true });
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },

    async deleteFaqBbs({ dispatch, commit }, id) {
        try {
            const response =  await faqBbsService.deleteFaqBbs(id)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },

    async createFaqBbsAttachment({ dispatch, commit }, bbsId, data) {
        try {
            const response =  await faqBbsService.createFaqBbsAttachment(bbsId, data)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },

    async deleteFaqBbsAttachment({ dispatch, commit }, bbsId) {
        try {
            const response =  await faqBbsService.deleteFaqBbsAttachment(bbsId)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async downloadFaqBbsAttachment({ dispatch, commit }, attachmentId) {
        try {
            const response =  await faqBbsService.downloadFaqBbsAttachment(attachmentId)
            if (response.data && response.data.data && response.data.data.url)
                downloadFileFromUrl(response.data.data.url)
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    // sub post
    async fetchFaqBbsSubPost({ dispatch, commit }, payload) {
        try {
            const response =  await faqBbsService.fetchFaqBbsSubPost(payload)
            if (response.success){
                commit('SET_SUB_FAQ_BBS_LIST_MODEL', response.data)
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async fetchFaqBbsCommentList({ dispatch, commit }, id) {
        try {
            const response =  await faqBbsService.fetchFaqBbsCommentList(id)
            if (response.success){
                commit('SET_COMMENT_LIST', response.data.data)
                return response.data.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async getFaqBbsComment({ dispatch, commit }, commentId) {
        try {
            const response =  await faqBbsService.getFaqBbsComment(commentId)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async createFaqBbsComment({ dispatch, commit }, comment) {
        try {
            const response =  await faqBbsService.createFaqBbsComment(comment)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            console.log(error)
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async updateFaqBbsComment({ dispatch, commit }, { commentId, payload }) {
        try {
            const response =  await faqBbsService.updateFaqBbsComment(commentId, payload)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async deleteFaqBbsComment({ dispatch, commit }, commentId) {
        try {
            const response =  await faqBbsService.deleteFaqBbsComment(commentId)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async createFaqBbsCommentAttachment({ dispatch, commit }, { commentId, data }) {
        try {
            const response =  await faqBbsService.createFaqBbsCommentAttachment(commentId, data)
            if (response.success){
                return response.data
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async deleteFaqBbsCommentAttachment({ dispatch, commit }, { commentId, data }) {
        try {
            const response =  await faqBbsService.deleteFaqBbsCommentAttachment(commentId, data)
            if (response.success){
                return true
            }else{
                dispatch("alertError", response.data.message, { root: true });
                return false
            }
        } catch (error) {
            const message = (error && error.data && error.data.message) || error.message;
            dispatch("alertError", message, { root: true });
            return false;
        }
    },
    async countUnreadFaqBbs({ dispatch, commit }) {
        try {
            const response =  await faqBbsService.countUnreadFaqBbs()
            if (response.success){
                commit('SET_UNREAD_FAQ_BBS', response.data.total)
                return response.data
            }else{
             //   dispatch("alertError", response.data.message, { root: true });
                return response
            }
        } catch (error) {
          //  const message = (error && error.data && error.data.message) || error.message;
          //  dispatch("alertError", message, { root: true });
            return [];
        }
    },
    async fetchChargeAdmins({ dispatch, commit }) {
        try {
          const response =  await faqBbsService.fetchChargeAdmins()
          if (response.success){
            commit('SET_CHARGE_ADMINS', response.data)
            return response.data
          }else{
            dispatch("alertError", response.data.message, { root: true });
            return response
          }
        } catch (error) {
          const message = (error && error.data && error.data.message) || error.message;
          dispatch("alertError", message, { root: true });
          return [];
        }
    },

}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
